import type { SinglePlatform, StreamPlatform } from "../../lib/stream-platform";

type PlatformTone = {
  card: string;
  bar: string;
  stroke: string;
};

// YouTube red and Twitch purple follow DESIGN.md; both and none stay neutral.
export const platformTones: Record<StreamPlatform, PlatformTone> = {
  YT: {
    card: "border-red-200 bg-red-50 text-red-800",
    bar: "bg-red-700",
    stroke: "#b91c1c",
  },
  Twitch: {
    card: "border-purple-200 bg-purple-50 text-purple-800",
    bar: "bg-purple-700",
    stroke: "#7e22ce",
  },
  both: {
    card: "border-neutral-300 bg-neutral-100 text-neutral-800",
    bar: "bg-neutral-900",
    stroke: "#171717",
  },
  none: {
    card: "border-neutral-200 bg-neutral-50 text-neutral-600",
    bar: "bg-neutral-500",
    stroke: "#737373",
  },
};

export const platformBadgeClasses: Record<SinglePlatform, string> = {
  YT: "border-red-200 bg-red-50 text-red-700",
  Twitch: "border-purple-200 bg-purple-50 text-purple-700",
};
